/**
 * Display label for an integration TYPE, e.g. "genesys" → "Genesys", "aspect_wfm" → "Aspect Wfm".
 * Brand nouns read the same in every language, so this is deliberately not i18n'd — it just
 * title-cases the raw type. Shared so the plan-import and org-config views can't drift apart.
 */
export var formatIntegrationTypeLabel = function (type) {
    return (type !== null && type !== void 0 ? type : '').replaceAll('_', ' ').replaceAll(/\b\w/g, function (c) { return c.toUpperCase(); });
};
/**
 * Display label for one named connection, e.g. "Aspect UK". The connection name is appended to the
 * type label unless it's absent or merely echoes the type (backfilled connections default their name
 * to the type).
 */
export var formatConnectionLabel = function (type, name) {
    var typeLabel = formatIntegrationTypeLabel(type);
    var trimmed = name === null || name === void 0 ? void 0 : name.trim();
    if (!typeLabel)
        return trimmed !== null && trimmed !== void 0 ? trimmed : '';
    if (!trimmed || trimmed.toLowerCase() === (type !== null && type !== void 0 ? type : '').toLowerCase())
        return typeLabel;
    return "".concat(typeLabel, " ").concat(trimmed);
};
